import { connectStats } from "instantsearch.js/es/connectors/index.js";

export const chamfrStats = connectStats((renderOptions, isFirstRender) => {
  const { nbHits, widgetParams } = renderOptions;
  const container = widgetParams.container;
  const text = nbHits ? `(${nbHits})` : "";
  container.innerHTML = text;
});
